// /sso?token=xxx を受けてアドバイザーポータルからのSSOログインを処理する。
// SSOトークンを /api/advisor/sso-consume に渡してセッション Cookie を取得し、
// 認証ストアを再ロードして /dashboard などにリダイレクトする。
import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '../stores/auth'
import { Loader2, AlertTriangle } from 'lucide-react'

export default function SsoLoginPage() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const checkAuth = useAuthStore((s) => s.checkAuth)
  const [error, setError] = useState('')

  useEffect(() => {
    const token = params.get('token')
    const advisorUrl = params.get('advisor_url') || 'https://cashflow-advisor.pages.dev'
    if (!token) {
      setError('SSOトークンがありません')
      return
    }
    ;(async () => {
      try {
        const res = await fetch('/api/advisor/sso-consume', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ token }),
        })
        if (!res.ok) {
          const j = await res.json().catch(() => ({}))
          throw new Error(j.error || `HTTP ${res.status}`)
        }
        // SSO経由フラグをセッションストレージに保存（このタブ間のみ有効）。
        // サイドバーに「アドバイザーポータルに戻る」リンクを表示するために使う。
        try {
          sessionStorage.setItem('advisor_origin', '1')
          sessionStorage.setItem('advisor_url', advisorUrl)
        } catch { /* ignore */ }
        await checkAuth()
        navigate('/dashboard', { replace: true })
      } catch (e) {
        setError(e instanceof Error ? e.message : 'SSOログインに失敗しました')
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-8 text-center">
        {error ? (
          <div>
            <AlertTriangle className="w-10 h-10 text-red-500 mx-auto mb-3" />
            <h1 className="text-lg font-bold text-gray-900 mb-2">SSOログイン失敗</h1>
            <p className="text-sm text-red-700">{error}</p>
            <button onClick={() => navigate('/')}
              className="mt-4 text-sm text-blue-600 hover:underline">
              トップへ戻る
            </button>
          </div>
        ) : (
          <div>
            <Loader2 className="w-10 h-10 text-blue-500 mx-auto mb-3 animate-spin" />
            <h1 className="text-lg font-bold text-gray-900">SSOログイン中...</h1>
            <p className="text-sm text-gray-500 mt-2">アドバイザーポータルからの認証を処理しています</p>
          </div>
        )}
      </div>
    </div>
  )
}
